/* Daily countdown for the advertorial offer: counts down to the next midnight in the given time zone. */
(() => {
  if (customElements.get('adv-daily-countdown')) return;

  // Next change of calendar date in the zone; respects 23/25-hour DST days.
  function nextMidnight(now, formatter) {
    const today = formatter.format(new Date(now));
    let low = Math.floor(now / 1000);
    let high = low + 48 * 3600;
    while (high - low > 1) {
      const middle = Math.floor((low + high) / 2);
      if (formatter.format(new Date(middle * 1000)) === today) low = middle;
      else high = middle;
    }
    return high * 1000;
  }

  class AdvDailyCountdown extends HTMLElement {
    connectedCallback() {
      clearInterval(this.interval);
      try {
        this.formatter = new Intl.DateTimeFormat('en-CA', {
          timeZone: this.dataset.timezone || 'Etc/UTC',
          year: 'numeric', month: '2-digit', day: '2-digit',
        });
      } catch (error) {
        this.hidden = true;
        console.warn('Advertorial countdown: invalid IANA time zone.', this.dataset.timezone);
        return;
      }
      this.hours = this.querySelector('[data-hours]');
      this.minutes = this.querySelector('[data-minutes]');
      this.seconds = this.querySelector('[data-seconds]');
      this.deadline = 0;
      this.tick();
      this.hidden = false;
      this.interval = setInterval(() => this.tick(), 1000);
    }

    tick() {
      const now = Date.now();
      const date = this.formatter.format(new Date(now));
      if (now >= this.deadline || date !== this.date) {
        this.deadline = nextMidnight(now, this.formatter);
        this.date = date;
      }
      const remaining = Math.max(0, Math.ceil((this.deadline - now) / 1000));
      this.hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
      this.minutes.textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
      this.seconds.textContent = String(remaining % 60).padStart(2, '0');
    }

    disconnectedCallback() { clearInterval(this.interval); }
  }

  customElements.define('adv-daily-countdown', AdvDailyCountdown);
})();